import { useRouteLoaderData } from 'react-router'
import type { SetNonNullable } from 'type-fest'
import type { RootLoader } from '#root.tsx'
import type { AppLoader } from '#routes/app.tsx'
import type { ReportLoader } from '#routes/report.tsx'
import type { UrlLoader } from '#routes/url.tsx'

export function useReportData() {
  return useRouteLoaderData<ReportLoader>('report')
}

export function useReportDataOrFail() {
  const data = useReportData()
  if (!data) throw new Error('No report route data found')

  return data as SetNonNullable<typeof data>
}

export function useAppData() {
  const data = useRouteLoaderData<AppLoader>('app')
  // We should always have app data
  if (!data) throw new Error('No appData found')

  return data as SetNonNullable<typeof data>
}

export function useUrlData() {
  return useRouteLoaderData<UrlLoader>('url')
}

export function useUrlDataOrFail() {
  const data = useUrlData()
  if (!data) throw new Error('No url route data found')

  return data as SetNonNullable<typeof data>
}

export function useRootData() {
  const data = useRouteLoaderData<RootLoader>('root')
  if (!data) throw new Error('No root data found')

  return data
}
